var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.16406,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    fill: "#E5F1FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.16406,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "#CBDCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9948 36.6667H38.6615C37.9255 36.6667 37.3281 36.0693 37.3281 35.3333V28.6667C37.3281 27.9307 37.9255 27.3333 38.6615 27.3333H39.9948C41.4681 27.3333 42.6615 28.5267 42.6615 30V34C42.6615 35.4733 41.4681 36.6667 39.9948 36.6667Z",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6641 36.6667H21.3307C19.8574 36.6667 18.6641 35.4733 18.6641 34V30C18.6641 28.5267 19.8574 27.3333 21.3307 27.3333H22.6641C23.4001 27.3333 23.9974 27.9307 23.9974 28.6667V35.3333C23.9974 36.0693 23.4001 36.6667 22.6641 36.6667Z",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3333 27.3333V26.6667C39.3333 21.88 35.4533 18 30.6667 18V18C25.88 18 22 21.88 22 26.6667V27.3333",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4974 42.3333H29.8307C28.9107 42.3333 28.1641 41.5867 28.1641 40.6667V40.6667C28.1641 39.7467 28.9107 39 29.8307 39H31.4974C32.4174 39 33.1641 39.7467 33.1641 40.6667V40.6667C33.1641 41.5867 32.4174 42.3333 31.4974 42.3333Z",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1641 40.6667H35.9974C37.4707 40.6667 38.6641 39.4733 38.6641 38V36.6667",
    stroke: "#0000FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support-icon.6d38dc3553d0cc74e26e86558e12e08e.svg";
export { ForwardRef as ReactComponent };